<template>

  <v-switch v-model="notificationsEnabled" :loading="loading" class="pt-2"></v-switch>

</template>

<script>
export default {
    name: 'Pushnots',
    props: ['popup'],
    data() {
        return {
            trigger: false,
            notificationsSupported: false,
            notificationsEnabled: false,
            serviceWorkerRegistation: null,
            subscription: null,
            loading: false,
        }
    },
    created() {
      console.log('pushsubscribe');
      if (this.popup) {
        console.log('popup');
      }
    },
    methods: {
        toggleSubscription() {
          this.loading = true;
            if (this.notificationsSupported) {
                if (this.notificationsEnabled) {
                    Notification.requestPermission()
                    .then(result => {
                        if (result === 'granted') {
                            this.createSubscription()
                            .then(sub => {
                                this.subscription = sub
                            })
                            .then( () => {
                                return axios.post(`/api/subscription`, {
                                    subscription: this.subscription
                                  })
                                  .then( () => {
                                    this.loading = false;
                                  })
                            })
                            // .then( () => {
                            //     this.notificationsEnabled = true
                            // })
                        }
                    })
                } else {
                    if (this.subscription !== null) {
                        return axios.post(`/api/subscription/delete`, {
                            endpoint: this.subscription.endpoint,
                        })
                        .then(() => this.subscription.unsubscribe())
                        .then(() => {
                            // this.notificationsEnabled = false
                            this.subscription = null
                            this.loading = false;
                        })
                    }
                }
            }
        },
        createSubscription() {
            if (this.serviceWorkerRegistation === null) {
                return navigator.serviceWorker.ready
                .then(swreg => {
                    this.serviceWorkerRegistation = swreg
                    // this.serviceWorkerRegistation.scope = window.location.origin;
                    return this.subscribe(this.serviceWorkerRegistation)
                })
            } else {
              // this.serviceWorkerRegistation.scope = window.location.origin;
                return this.subscribe(this.serviceWorkerRegistation)
            }
        },
        getSubscription(swreg) {
            return swreg.pushManager.getSubscription()
        },
        subscribe(swreg) {
            const vapidPublicKey = process.env.MIX_VAPID_PUBLIC_KEY
            const convertedVapidPublicKey = this.urlBase64ToUint8Array(vapidPublicKey)
            return swreg.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: convertedVapidPublicKey,
                scope: './',
            })
        },
        findSubscription() {
            return navigator.serviceWorker.ready
            .then(swreg => {
                this.serviceWorkerRegistation = swreg
                return this.getSubscription(this.serviceWorkerRegistation)
            })
        },
        urlBase64ToUint8Array(base64String) {
            const padding = '='.repeat((4 - base64String.length % 4) % 4);
            const base64 = (base64String + padding)
                .replace(/\-/g, '+')
                .replace(/_/g, '/');
            const rawData = window.atob(base64);
            let outputArray = new Uint8Array(rawData.length);
            for (let i = 0; i < rawData.length; ++i) {
                outputArray[i] = rawData.charCodeAt(i);
            }
            return outputArray;
        },
    },
    watch: {
      notificationsEnabled: function () {
        if(this.trigger) {
          this.toggleSubscription();
        }
      }
    },
    created() {
        if ('Notification' in window && 'serviceWorker' in navigator) {
            this.notificationsSupported = true
        } else {
          this.$emit('pushSupported', false);
        }
    },
    mounted() {
        this.findSubscription()
        .then(sub => {
            if (sub === null) {
                this.buttonDisabled = false
                this.notificationsEnabled = false
            } else {
                this.buttonDisabled = false
                this.notificationsEnabled = true
                this.subscription = sub
            }
        }).then(() => {
          this.trigger = true;
        })
    },
}
</script>
